import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    connect(): void {
        document.addEventListener("htmx:afterSettle", this.sync);
        this.sync();
    }

    disconnect(): void {
        document.removeEventListener("htmx:afterSettle", this.sync);
        document.getElementById("support-access-diagnostic-toggle")?.classList.add("hidden");
    }

    clickDebug(event: MouseEvent): void {
        if (event.target instanceof Element && event.target.closest('[data-admin-panel-trigger="debug"]')) this.toggleDebug();
    }

    toggleDebug(): void {
        this.element.classList.toggle("admin-debug-open");
        this.sync();
        if (this.element.classList.contains("admin-debug-open")) {
            this.element.querySelector<HTMLButtonElement>("#ticket-admin-debug-panel button")?.focus();
        }
    }

    close(): void {
        this.element.classList.remove("admin-debug-open");
        this.sync();
        document.querySelector<HTMLButtonElement>('[data-admin-panel-trigger="debug"]')?.focus();
    }

    keydown(event: KeyboardEvent): void {
        if (event.key === "Escape" && this.element.classList.contains("admin-debug-open") && !document.querySelector("dialog[open]")) this.close();
    }

    private sync = (): void => {
        const debug = this.element.classList.contains("admin-debug-open");
        document.getElementById("support-access-diagnostic-toggle")?.classList.toggle("hidden", !this.element.querySelector("#ticket-admin-debug-panel"));
        document.querySelector('[data-admin-panel-trigger="debug"]')?.setAttribute("aria-expanded", String(debug));
    };
}
